/**
 * How a score is written down.
 *
 * Here rather than in `shared/`, because this is presentation and not domain:
 * the rule about scores that the domain holds is that they are never converted
 * between scales, and that rule lives with the scale. This one is about the
 * decimal comma — or the point, when the interface is in English.
 *
 * Read by the wine's page, which lists every reading, and by the list row,
 * which prints the latest from each source — the two must not disagree about
 * whether Vivino's number is `4,1` or `4.1`.
 */

import { locale } from "./locale.js";

/** A whole number stays whole: 17, not 17,0. */
export function formatScore(score: number, hasDecimals: boolean): string {
  return hasDecimals && !Number.isInteger(score)
    ? score.toLocaleString(locale(), { minimumFractionDigits: 1 })
    : String(score);
}
